function e(a, c) {
  return a.has(c);
}
var r = e;
export {
  r as default
};
//# sourceMappingURL=_cacheHas.js.map
